// extracted by mini-css-extract-plugin
export default {"joint-owner-col-block":"UpdateJointOwnerForm_joint-owner-col-block__X2tlT","no-joint-owner-text":"UpdateJointOwnerForm_no-joint-owner-text__ZfYH5"};